<template>
    <div id="member-printing-detail">
        <div id="member-printing-detail-header">
            <img class="member-printing-detail-back" src="../../assets/common_back.png" alt=""
                 @click="back">
            <span class="member-printing-detail-title">会员中心</span>
        </div>

        <div id="member-printing-detail-body-bg">
            <div id="member-printing-detail-body">
                <div class="member-header">
                    <div class="header-detail" :class="{'cur': curId === 0}" @click="curId = 0">
                        印花明细
                    </div>
                    <div class="header-detail" :class="{'cur': curId === 1}" @click="curId = 1">
                        印花说明
                    </div>
                    <div class="header-detail" :class="{'cur': curId === 2}" @click="curId = 2">
                        登陆记录
                    </div>
                </div>

                <printing-detail v-show="curId === 0"></printing-detail>
                <printing-explain v-show="curId === 1"/>
                <login-record v-show="curId === 2"></login-record>
            </div>
        </div>

        <div class="back-btn" @click="back">返回</div>

        <div class="member-printing-detail-icon">
            <img
                    src="../../assets/member_print_description_bottom_icon.png"
                    alt="">
        </div>
    </div>
</template>

<script>
    import PrintingExplain from "../../components/PrintingExplain";
    import LoginRecord from "../../components/LoginRecord";
    import PrintingDetail from "../../components/PrintingDetail";

    export default {
        name: "MemberPrintingDetail",

        components: {PrintingDetail, PrintingExplain, LoginRecord},

        data() {
            return {
                curId: 0,
            }
        },

        methods: {
            back() {
                this.$router.go(-1)
            },
        }
    }
</script>

<style scoped lang="scss">
    #member-printing-detail {
        /*background-color: #f2f2f2;*/
        width: 100%;
        height: 100%;

        //header区域
        #member-printing-detail-header {
            height: 45px;
            line-height: 45px;
            width: 100%;
            background-color: #ed3f14;
            top: 0;
            position: fixed;
            z-index: 1;
            margin-bottom: 10px;

            .member-printing-detail-back {
                margin-top: 13px;
                line-height: 35px;
                margin-left: 10px;
                float: left;
            }

            .member-printing-detail-title {
                color: white;
            }
        }

        //body区域
        #member-printing-detail-body {
            margin: 35px 10px 10px 10px;
            border-radius: 15px;
            background-color: white;
            padding: 20px;
            clear: both;

            .member-header {
                height: 60px;
                width: 100%;
                border: 1px dashed #c1c5c8;
                border-radius: 10px;

                .cur {
                    color: #2d8cf0;
                }

                .header-detail {
                    width: 33%;
                    float: left;
                    line-height: 60px;
                    text-align: center;
                }
            }
        }

        .member-printing-detail-icon {
            position: fixed;
            bottom: 0;

            img {
                margin-bottom: -5px;
                width: 100%;
            }
        }

        .back-btn {
            background: #fdf9f7;
            margin: auto;
            width: 80%;
            font-size: 1rem;
            font-weight: bold;
            color: #ea2d53;
            border: 1px solid #ea2d53;
            border-radius: 5px;
            padding: 10px;
            margin-bottom: 3rem;
        }

    }
</style>